

import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ILocationDetails } from 'src/app/models/ILocationDetails';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { MatDialog } from '@angular/material';
import { Defaults } from 'src/app/Utilities/defaults';
import { Measures } from 'src/app/models/Measures';
import { CQMSConfigurationService } from 'src/app/Services/CQMSConfiguration/cqmsconfiguration.service';
import { ICQMSMonths } from 'src/app/models/ICQMSMonths';

interface CqmsYears {
  yearId: number;
  yearName: string;
}

export interface PeriodicElement {
  Qualifingcodes: string;
  Measure: string;
  Count: string;

}

@Component({
  selector: 'app-cqms-qualifing-codes',
  templateUrl: './cqms-qualifing-codes.component.html',
  styleUrls: ['./cqms-qualifing-codes.component.css']
})
export class CqmsQualifingCodesComponent implements OnInit {


  displayedColumns: string[] = ['Qualifingcodes', 'Measure', 'Count'];
  //dataSource1 = ELEMENT_DATA;

  lstYears: CqmsYears[] = [
    { yearId: 1, yearName: '2018' },
    { yearId: 2, yearName: '2019' },
    { yearId: 3, yearName: '2020' }
  ];

  QualifyingCodesForm: FormGroup;
  public lstLocations: ILocationDetails[];
  public lstProviders: IUserDetails[];
  public advancedCareList: Measures[] = [];
  public lstMonths: ICQMSMonths[];
  public lstWeeks: ICQMSMonths[] = [];

  constructor(private formBuilder: FormBuilder
    , private schedulerservice: SchedularServiceService
    , public datepipe: DatePipe
    , private toastr: ToastrService
    , private sharedService: SharedService
    , public dialog: MatDialog
    , private router: Router
    , private cqmsConfigurationService: CQMSConfigurationService) { }


  onClickFilling() {
    this.router.navigate(['CqmsFailingPatient']);
  }
  ngOnInit() {
    this.QualifyingCodesForm = this.formBuilder.group({

    });
    this.getProviders();
    this.getLocations();
    this.getAdvancedCarePlan();
    this.getAllMonths();
    this.getAllWeeks();
  }
  getProviders() {
    this.sharedService.getAllUsersByRole(Defaults.doctorType).subscribe(data => {
      this.lstProviders = data;
    });
  }
  getLocations() {
    this.schedulerservice.getLocations().subscribe(data => {
      this.lstLocations = data;
      this.lstLocations = this.lstLocations.filter(a => a.active == true)
    });
  }
  getAdvancedCarePlan() {
    this.cqmsConfigurationService.GetAllMeasuresNames().subscribe(
      data => {
        this.advancedCareList = data;
      });
  }
  getAllMonths() {
    this.cqmsConfigurationService.GetAllMonths().subscribe(data => {
      this.lstMonths = data;
    });
  }
  getAllWeeks() {
    this.cqmsConfigurationService.GetAllWeeks().subscribe(data => {
      this.lstWeeks = data;
    });
  }
}
